<template>
  <div class="nav-bottom-page" :class="!showbar?'display-none':''">
    <div class="nav-bottom-page-content  flex-column-center">
      <div style="width: 1220px;opacity: 0.8;height: 120px;" class="flex-row-center">
        <el-row>
          <el-col :span="12">
            <p class="font-14" style="color: rgba(255, 255, 255, 0.4);line-height: 30px">策划团队 <span style="margin-left: 24px" class="font-color-fff">上海健康医学院“红色数字医学”团队</span> </p>
          </el-col>
          <el-col :span="12">
            <p class="font-14" style="color: rgba(255, 255, 255, 0.4);line-height: 30px">技术支持<span style="margin-left: 24px" class="font-color-fff">北京爱迪科森教育科技股份有限公司</span><span class="font-color-fff" style="margin-left:20px">邮箱 market@bjadks.com</span> </p>
          </el-col>
          <el-col :span="12">
            <p class="font-14" style="color: rgba(255, 255, 255, 0.4);line-height: 30px">版权所有<span style="margin-left: 24px" class="font-color-fff">上海健康医学院版权所</span><span class="font-color-fff" style="margin-left:20px">上海市浦东新区周祝公路279号</span> </p>
          </el-col>
          <el-col :span="12">
            <p class="font-14" style="color: rgba(255, 255, 255, 0.4);line-height: 30px">问题反馈<span style="margin-left: 24px" class="font-color-fff"> 电话 021-12345678</span> </p>
          </el-col>
        </el-row>
      </div>
      <div style="margin: auto;height: 80px">
        <p class="font-14" style="color: rgba(255, 255, 255, 0.4);line-height: 80px"><span>沪ICP备17001211号-1</span><span style="margin-left: 24px">沪公网安备31011502006839号</span></p>
      </div>
    </div>
    <div
      style="position: absolute;left: 0px;right: 0px;top: 120px;width: 100%;height: 1px;background: #222;"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showbar: true,
      str0: '      ',
      str1: '版权所有 ：保定学院图书馆　　地址：河北省保定市七一东路3027号　　电话：0312-5972155 5972057　　电邮：lib@bdu.edu.cn　　邮编：071000'
    }
  }
}
</script>

<style  lang="scss" scoped>
  .nav-bottom-page {
    width: 100%;
    height: 200px;
    background-color: #111;
    position: relative;
  }

  .nav-bottom-page-content {
    width: 1220px;
    margin: 0 auto;
    height: 200px;
  }

  .nav-bottom-page-content p {
    color: rgba(255, 255, 255, 0.5);
    line-height: 22px;
  }

  .display-none {
    display: none;
  }
</style>
